import { get } from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import {
  FormattedMessage,
  /* Kware Start Editing */
  injectIntl,
  /* Kware end Editing */
} from 'react-intl';

import {
  Row,
  Col,
  KeyValue,
  Accordion,
  Headline,
  NoValue,
  FormattedDate,
} from '@folio/stripes/components';
import { ViewMetaData } from '@folio/stripes/smart-components';
/* Kware Start Editing */
import { withStripes } from '@folio/stripes-core';
/* Kware end Editing */
import { useStripes } from '@folio/stripes/core';

import { USER_TYPE_FIELD, USER_TYPES } from '../../../constants';
import ProfilePicture from '../../ProfilePicture';

const UserInfo = (props) => {
  const {
    /* Kware Start Editing */
    user: { personal: { lastName, firstName, middleName, preferredFirstName }, metadata },
    intl,
    /* Kware end Editing */
    user,
    patronGroup,
    settings,
    expanded,
    accordionId,
    onToggle
  } = props;
  const profilePictureLink = user?.personal?.profilePictureLink;
  const stripes = useStripes();
  const userStatus = (user?.active ?
    <FormattedMessage id="ui-users.active" /> :
    <FormattedMessage id="ui-users.inactive" />);
  const profilePicturesEnabled = Boolean(settings.length) && settings[0].enabled;
  const hasViewProfilePicturePerm = stripes.hasPerm('ui-users.profile-pictures.view');
  const isShadowUser = user?.type === USER_TYPES.SHADOW;
  const displayProfilePicture = profilePicturesEnabled && hasViewProfilePicturePerm && !isShadowUser;

  return (
    <Accordion
      open={expanded}
      id={accordionId}
      onToggle={onToggle}
      label={(
        <Headline
          size="large"
          tag="h3"
        >
          <FormattedMessage id="ui-users.information.userInformation" />
        </Headline>)}
    >
      <Row>
        <Col xs={12}>
          <ViewMetaData metadata={user?.metadata} />
        </Col>
      </Row>
      <Row>
        <Col xs={displayProfilePicture ? 9 : 12}>
          <Row>
            {/* Kware Start Editing */}
            <Col xs={3}>
              <KeyValue
                label={<FormattedMessage id="ui-users.information.lastName" />}
                value={lastName ? <FormattedMessage id={`ui-users.userInfo.lastName.${lastName}`} defaultMessage={lastName} /> : '-'}
              />
            </Col>
            <Col xs={3}>
              <KeyValue
                label={<FormattedMessage id="ui-users.information.firstName" />}
                value={firstName ? <FormattedMessage id={`ui-users.userInfo.firstName.${firstName}`} defaultMessage={firstName} /> : '-'}
              />
            </Col>
            <Col xs={3}>
              <KeyValue
                label={<FormattedMessage id="ui-users.information.middleName" />}
                value={middleName ? <FormattedMessage id={`ui-users.userInfo.middleName.${middleName}`} defaultMessage={middleName} /> : '-'}
              />
            </Col>
            <Col xs={3}>
              <KeyValue
                label={<FormattedMessage id="ui-users.information.preferredName" />}
                value={preferredFirstName ? <FormattedMessage id={`ui-users.userInfo.preferredFirstName.${preferredFirstName}`} defaultMessage={preferredFirstName} /> : '-'}
              />
            </Col>
            {/* Kware end Editing */}
          </Row>

          <Row>
            <Col xs={3}>
              <KeyValue
                label={<FormattedMessage id="ui-users.information.patronGroup" />}
                /* Kware Start Editing */
                value={patronGroup.group ? <FormattedMessage id={`ui-users.patronGroups.group.${patronGroup.group}`} defaultMessage={patronGroup.group} /> : '-'}
                /* Kware end Editing */
              />
            </Col>
            <Col xs={3}>
              <KeyValue
                label={<FormattedMessage id="ui-users.information.status" />}
                value={userStatus}
              />
            </Col>
            <Col xs={3}>
              <KeyValue
                label={<FormattedMessage id="ui-users.information.expirationDate" />}
                value={user.expirationDate ? <FormattedDate value={user.expirationDate} /> : '-'}
              />
            </Col>
            <Col xs={3}>
              <KeyValue
                label={<FormattedMessage id="ui-users.information.barcode" />}
                value={get(user, ['barcode'], '')}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={3}>
              <KeyValue
                label={<FormattedMessage id="ui-users.information.userType" />}
                value={get(user, [USER_TYPE_FIELD], '')}
              />
            </Col>
            {/* kware start edit - Display clearance status */}
            {user?.customFields?.clearanceStatus === 'cleared' && (
              <>
                <Col xs={3}>
                  <KeyValue
                    label={<FormattedMessage id="ui-users.clearance.status.cleared" />}
                    value="✓"
                  />
                </Col>
                <Col xs={3}>
                  <KeyValue
                    label={<FormattedMessage id="ui-users.clearance.date" />}
                    value={user?.customFields?.clearanceDate ? <FormattedDate value={user.customFields.clearanceDate} /> : '-'}
                  />
                </Col>
              </>
            )}
            {/* kware end edit */}
          </Row>
        </Col>

        {
          displayProfilePicture &&
          <Col xs={3}>
            <Row>
              <Col xs={12}>
                <KeyValue
                  label={<FormattedMessage id="ui-users.information.profilePicture" />}
                  value={<ProfilePicture profilePictureLink={profilePictureLink} />}
                />
              </Col>
            </Row>
          </Col>
        }
      </Row>
    </Accordion>
  );
};

UserInfo.propTypes = {
  expanded: PropTypes.bool,
  onToggle: PropTypes.func,
  accordionId: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,
  patronGroup: PropTypes.object.isRequired,
  settings: PropTypes.arrayOf(PropTypes.object).isRequired,
  /* Kware Start Editing */
  intl: PropTypes.object
  /* Kware end Editing */
};

// export default UserInfo;
/* Kware Start Editing */
export default withStripes(injectIntl(UserInfo));
/* Kware end Editing */
